import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItemHeader } from './NavItemHeader';

export function NavItem(props) {
  const { label, Icon, to, children } = props.item;
  if (children) {
    return (
      <NavItemHeader
        item={props.item}
        data-testid={`nav-item-header-${label
          .replace(/[^a-zA-Z0-9]/g, '-')
          .toLowerCase()}`}
      />
    );
  }

  return (
    <li
      className="spectrum-SideNav-item"
      data-testid={`nav-item-${label
        .replace(/[^a-zA-Z0-9]/g, '-')
        .toLowerCase()}`}
    >
      <NavLink
        to={to}
        className={({ isActive }) =>
          isActive
            ? 'spectrum-SideNav-itemLink is-selected'
            : 'spectrum-SideNav-itemLink'
        }
        data-testid={`nav-link-${label
          .replace(/[^a-zA-Z0-9]/g, '-')
          .toLowerCase()}`}
      >
        {Icon && (
          <Icon
            size="S"
            data-testid={`nav-icon-${label
              .replace(/[^a-zA-Z0-9]/g, '-')
              .toLowerCase()}`}
          />
        )}
        <span
          className="side-nav-label"
          data-testid={`nav-label-${label
            .replace(/[^a-zA-Z0-9]/g, '-')
            .toLowerCase()}`}
        >
          {label}
        </span>
      </NavLink>
    </li>
  );
}
